import React from "react";
import styles from "./Dashboard.module.css";

type Value = "volume" | "count";

type Props = {
  value: Value;
  onChange: (v: Value) => void;
};

const MobileTabs = ({ value, onChange }: Props) => {
  return (
    <div className={styles.mobileTimelineTabs}>
      <button
        className={
          value === "volume"
            ? `${styles.mobileTimelineTab} ${styles.mobileTimelineTabActive} ${styles.leftActive}`
            : `${styles.mobileTimelineTab} ${styles.mobileTimelineTabInactive} ${styles.rightInactive}`
        }
        onClick={() => onChange("volume")}
      >
        Invested capital
        <span className={styles.mobileTimelineTabSubtitle}>in CHF Mio.</span>
      </button>
      <button
        className={
          value === "count"
            ? `${styles.mobileTimelineTab} ${styles.mobileTimelineTabActive} ${styles.rightActive}`
            : `${styles.mobileTimelineTab} ${styles.mobileTimelineTabInactive} ${styles.leftInactive}`
        }
        onClick={() => onChange("count")}
      >
        Number of deals
      </button>
    </div>
  );
};

export default MobileTabs;
